export const URL_HASHES = {
    openBiddingModal: 'bidding=1',
    saveInWishlist: 'wishlist=1',
    openBinModal: 'bin=1',
    openChangeCombinedShippingModal: 'open_change_combined_shipping=',
    markAsPaid: 'mark_as_paid=',
    hasRequestedCombinedShipping: 'has_requested_combined_shipping=',
    openReferralModal: 'show_referral=1',
    buyShopItem: 'shop_item=1'
};
